import userUtil from '@/utils/user';

export default function AuthContainer({ authCodes, hasAny, children }) {
    if (userUtil.hasAuth(authCodes, hasAny)) {
        return children;
    } else {
        return null;
    }
}